import React from "react";
import {Box, Button, Container, Typography} from "@mui/material";
import {CtrlKb1, CtrlKb2, CtrlKb3, CtrlKb4, CtrlKb5, CtrlKb6, CtrlKb7, CtrlKb8, CtrlKb9} from "../SvsForm";
import {getsvkCdList} from "../../../api/client";

export default function Step2(props) {
  // const loadParams = (nm) => {
  //   return sessionStorage.getItem(nm) || "";
  // };
  const saveParams = (nm, val) => {
    return sessionStorage.setItem(nm, val);
  };
  const loadJson = (nm) => {
    return JSON.parse(sessionStorage.getItem(nm)) || [];
  };
  const saveJson = (nm, val) => {
    return sessionStorage.setItem(nm, JSON.stringify(val));
  };
  async function nextStep(val) {
    if (Boolean(val)) {
      const svsCd = val.svsCd;
      const hourfDt = val.hourfDt;
      const hourtDt = val.hourtDt;
      const svkCdList = await getsvkCdList({ymdDt: props.propState.date, bsJg: props.propState.jgCd, riyoNo: props.propState.riyoNo, svsCd: svsCd, hourfDt: hourfDt, hourtDt: hourtDt, array: val}).catch(error => props.errorFunc(error));
      if (Boolean(svkCdList)) {
        saveJson("svkCdList", svkCdList.data);
        props.setState({...props.state, activeStep: props.state.activeStep + 1});
        saveParams("activeStep", props.state.activeStep + 1);
        // props.setValue("svkCd", Boolean(svkCdList.data) ? svkCdList.data[0][0] : "");
      };
    };
  };

  return (
    <Container>
      {loadJson("svsForm").map((form) => (
        <Box
          key = {"svsForm" + form.itemNm}
          sx = {{display: "flex", mt: 2, mb: 2}}
        >
          {form.ctrlKb === "1" &&
          <CtrlKb1 control = {props.control} form = {form} />}
          {form.ctrlKb === "2" &&
          <CtrlKb2 control = {props.control} form = {form} />}
          {form.ctrlKb === "3" &&
          <CtrlKb3 control = {props.control} form = {form} getValues = {props.getValues} />}
          {form.ctrlKb === "4" &&
          <CtrlKb4 />}
          {form.ctrlKb === "5" &&
          <CtrlKb5 form = {form} register = {props.register} />}
          {form.ctrlKb === "6" &&
          <CtrlKb6 />}
          {form.ctrlKb === "7" &&
          <CtrlKb7 />}
          {form.ctrlKb === "8" &&
          <CtrlKb8 />}
          {form.ctrlKb === "9" &&
          <CtrlKb9 />}
        </Box>
      ))}
      <Box
        sx = {{display: "flex", mt: 2, mb: 2}}
      >
        <Button
          className = "btn-prev"
          onClick = {() => {
            props.setState({...props.state, activeStep: props.state.activeStep - 1});
            saveParams("activeStep", props.state.activeStep - 1);
            let editScheduleStepper = loadJson("editScheduleStepper");
            loadJson("svsForm").map((form) => {
              props.unregister(form.itemNo + (Boolean(form.cdKb) ? ("_" + form.cdKb) : ""))
              delete editScheduleStepper[form.itemNo + (Boolean(form.cdKb) ? ("_" + form.cdKb) : "")];
              return false;
            });
            saveJson("editScheduleStepper", editScheduleStepper);
            sessionStorage.removeItem("svsForm");
          }}
          sx = {{display: "block", mr: "auto", pt: 0.5, pb: 0.5, width: 120}}
        >
          <Typography
            className = "btn-txt-sm"
          >
            戻る
          </Typography>
        </Button>
        <Button
          className = "btn-submit"
          onClick = {() => nextStep(props.getValues())}
          sx = {{display: "block", ml: "auto", pt: 0.5, pb: 0.5, width: 120}}
        >
          <Typography
            className = "btn-txt-sm"
          >
            次へ
          </Typography>
        </Button>
      </Box>
    </Container>
  );
};
